import { NotificationType } from '@prisma/client';
import { RouterOutputs } from './api';
import { Routes } from '~/config';

type Notification = RouterOutputs['notifications']['getNotifications']['notifications'][0];

export const getNotificationNavigation = (
  notification: Notification,
  workspaceId?: string,
): string | null => {
  const prefix = workspaceId ? `/${workspaceId}` : '';

  switch (notification.type) {
    case NotificationType.SCANNER_RUN_COMPLETED: {
      const scanReportId = notification.entity?.ScannerRunDocuments[0]?.scannerReportId;
      return `${prefix}${Routes.CONTENT_SCANNER}/dashboard?orderBy=name_DESC${scanReportId ? `&reportId=${scanReportId}` : ''}`;
    }
    case NotificationType.FEEDBACK_ANNOTATION_CREATED: {
      // Navigate to the content scanner dashboard where annotations can be reviewed
      return `${prefix}${Routes.POLICY_ENGINE}/policy-annotations?id=${notification.entityId}`;
    }
    default:
      return null;
  }
};
